import { BaseApiService } from '@services/baseApiService';
import { AffiliateOutputDTO } from '@types';
import { uploadFile } from '@services/uploadService';
import { ApiResponse, ApiError } from '@/types/api';

class AffiliateService extends BaseApiService<AffiliateOutputDTO> {
  constructor() {
    super('affiliates');
  }

  async create(data: Partial<AffiliateOutputDTO>): Promise<ApiResponse<AffiliateOutputDTO> | ApiError> {
    const logoFile = data.logo instanceof File ? data.logo : null;
    const backgroundFile = data.background instanceof File ? data.background : null;
    // Remove o arquivo do payload antes de criar
    const affiliateData = {
      ...data,
      logo: undefined,
      background: undefined
    };
    
    // Primeiro cria o afiliado
    const response = await super.create(affiliateData);
    // Se houver arquivo e a criação foi bem sucedida, faz o upload
    if (logoFile && 'data' in response && response.data?._id) {
      await uploadFile(
        logoFile,
        {
          upload_origin: 'affiliate_logo',
          params: {
            affiliateId: response.data._id,
          }
        },
        `/affiliates/${response.data._id}/logo`,
      );
    }
    if (backgroundFile && 'data' in response && response.data?._id) {
      await uploadFile(
        backgroundFile,
        {
          upload_origin: 'affiliate_background',
          params: {
            affiliateId: response.data._id,
          }
        },
        `/affiliates/${response.data._id}/background`,
      );
    }
    
    
    return response;
  }

  async update(id: string, data: Partial<AffiliateOutputDTO>): Promise<ApiResponse<AffiliateOutputDTO> | ApiError> {
    const logoFile = data.logo instanceof File ? data.logo : null;
    const backgroundFile = data.background instanceof File ? data.background : null;
    // Remove o arquivo do payload antes de atualizar
    const affiliateData = {
      ...data,
      logo: undefined,
      background: undefined
    };
    
    // Primeiro atualiza o afiliado
    const response = await super.update(id, affiliateData);
    
    // Se houver arquivo e a atualização foi bem sucedida, faz o upload
    if (logoFile && 'data' in response  && response.data?._id) {
      await uploadFile(
        logoFile,
        {
          upload_origin: 'affiliate_logo',
          params: {
            affiliateId: id,
          }
        },
        `/affiliates/${response.data._id}/logo`,
      );
    }
    if (backgroundFile && 'data' in response && response.data?._id) {
      await uploadFile(
        backgroundFile,
        {
          upload_origin: 'affiliate_background',
          params: { 
            affiliateId: id,
          }
        },
        `/affiliates/${response.data._id}/background`,
      );
    }
    
    return response;
  }

  // Você pode adicionar métodos específicos para Affiliate aqui, se necessário
}

export const affiliateService = new AffiliateService(); 